const storageFilters = {
  avaliation: true,
  service: true,
  attendance: true,
  response: true,
  profile: true,
  note: true,
  attendant: true,
  group: true,
  attendantQuality: true,
  contact: true,
  channel: true,
  status: true,
};

const getDataFromStorage = (storagedData, initialData) => {
  for (const key in storagedData) {
    initialData[key] = storagedData[key];
  }
  return initialData;
};

//const initialState = storageFilters;
const initialState = localStorage.getItem(
  "filters_quality_agent_dealing_columns"
)
  ? getDataFromStorage(
      JSON.parse(localStorage.getItem("filters_quality_agent_dealing_columns")),
      storageFilters
    )
  : storageFilters;

const columnsDealingAgent = (state = initialState, action) => {
  switch (action.type) {
    case "CHANGE_COLUMNS_DEALING_QUALITY_AGENT":
      return {
        avaliation: action.avaliation,
        service: action.service,
        attendance: action.attendance,
        response: action.response,
        profile: action.profile,
        note: action.note,
        attendant: action.attendant,
        group: action.group,
        attendantQuality: action.attendantQuality,
        contact: action.contact,
        channel: action.channel,
        status: action.status,
      };
    default:
      return state;
  }
};

export default columnsDealingAgent;
